export default __webpack_public_path__ + "static/Economic Model Update - Korean-4dbee3eab66719c9d679aa9a388a04ef.pdf";